// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","accessModalButton":"IEUDh7vfx3zMjJi4RM9pw","accessModalFooter":"Hx24-qGlY5-sn40uExoqy"};